import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Actions } from '../../store/actions/adobeSaas';
import BrandMetadata from '../templates/BrandMetadata';

class AdobeClassicBrandMetaData extends React.PureComponent{
  render() {
    return <BrandMetadata
      {...this.props}
      prefix="adobeSaas"
    />
  }
}

AdobeClassicBrandMetaData.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  fetchData: PropTypes.func
}

function mapStateToProps(state) {
  return {
    data: state.adobeSaas.brandMetaData.data,
    loading: state.adobeSaas.brandMetaData.loading,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchData() {
      dispatch(Actions.fetchBrandMetaData());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdobeClassicBrandMetaData)